document.addEventListener('click',function(event){const trigger=event.target.closest('[data-pc-dialog]');if(trigger){const dialog=document.getElementById(trigger.dataset.pcDialog);if(dialog){dialog.showModal();dialog.dataset.triggerId=trigger.id||'';}}const close=event.target.closest('[data-pc-close]');if(close){close.closest('dialog').close();}});
document.querySelectorAll('.pc-dialog').forEach(function(dialog){dialog.addEventListener('click',function(event){if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});});

(function () {
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: document.querySelector('[data-pc-currency]')?.dataset.pcCurrency || 'EUR'});
  function initialize(root) {
    root.querySelectorAll('.pc-localization-form').forEach(function (form) {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const country = form.querySelector('[data-pc-country]');
      const language = form.querySelector('[data-pc-language]');
      country.addEventListener('change', function () {
        language.value = country.selectedOptions[0].dataset.language || 'en';
        if (country.selectedOptions[0].dataset.euroFallback === 'true') country.value = 'ES';
        try { localStorage.setItem('paseo-country-choice', country.value); } catch (_) {}
        form.requestSubmit();
      });
      language.addEventListener('change', function () { form.requestSubmit(); });
    });
    root.querySelectorAll('[data-pc-countdown]').forEach(function (timer) {
      if (timer.dataset.initialized) return;
      timer.dataset.initialized = 'true';
      const value = timer.dataset.deadline;
      if (!/T.*(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return;
      const deadline = Date.parse(value);
      if (!Number.isFinite(deadline)) return;
      let interval;
      function tick() {
        const remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        timer.hidden = remaining === 0;
        if (!remaining) { clearInterval(interval); return; }
        const values = {days:Math.floor(remaining / 86400),hours:Math.floor(remaining / 3600) % 24,minutes:Math.floor(remaining / 60) % 60,seconds:remaining % 60};
        Object.keys(values).forEach(function (unit) { timer.querySelector('[data-unit="'+unit+'"]').textContent = String(values[unit]).padStart(2,'0'); });
      }
      interval = setInterval(tick, 1000);
      tick();
    });
    root.querySelectorAll('[data-pc-money]').forEach(function (node) {
      node.textContent = money.format(Number(node.dataset.pcMoney) / 100);
    });
    root.querySelectorAll('[data-pc-purchase]').forEach(function (purchase) {
      if (purchase.dataset.initialized) return;
      purchase.dataset.initialized = 'true';
      function update() {
        const selected = purchase.querySelector('[data-pc-pack]:checked');
        if (!selected) return;
        const amount = money.format(Number(selected.dataset.cents) / 100);
        purchase.querySelector('[data-pc-total]').textContent = amount;
        document.querySelectorAll('[data-pc-head-price]').forEach(function (node) { node.textContent = amount; });
        document.querySelectorAll('[data-pc-sale-comparison]').forEach(function (node) { node.hidden = node.dataset.variantId !== selected.value; });
        const buy = purchase.querySelector('[data-pc-buy]');
        buy.disabled = buy.dataset.pcLocked === 'true' || selected.dataset.available !== 'true';
      }
      purchase.addEventListener('change', function (event) { if (event.target.matches('[data-pc-pack]')) update(); });
      purchase.querySelector('form').addEventListener('submit', function (event) {
        if (purchase.querySelector('[data-pc-buy]').disabled) event.preventDefault();
      });
      update();
    });
  }
  initialize(document);
  async function localizeVisitor() {
    const context = document.querySelector('[data-pc-localization-context]');
    if (!context || context.dataset.designMode === 'true') return;
    // Respect deliberate country choices and avoid a redirect loop, including when storage is blocked.
    try {
      if (localStorage.getItem('paseo-country-choice') || sessionStorage.getItem('paseo-location-checked')) return;
      sessionStorage.setItem('paseo-location-checked', 'true');
    } catch (_) { return; }
    const available = context.dataset.countries.split(',');
    let target = 'ES';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true', {signal: AbortSignal.timeout(4000)});
      if (!response.ok) throw new Error('Localization unavailable');
      const result = await response.json();
      const detected = result.detected_values?.country?.handle;
      if (available.includes(detected) && !['AR', 'CL', 'CO'].includes(detected)) target = detected;
    } catch (_) { /* Spain supplies the fixed EUR catalog when detection is unavailable. */ }
    try { if (localStorage.getItem('paseo-country-choice')) return; } catch (_) { return; }
    if (target === context.dataset.country || !available.includes(target)) return;
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;
    const values = {_method: 'PUT', form_type: 'localization', country_code: target, return_to: location.pathname + location.search + location.hash};
    for (const [name, value] of Object.entries(values)) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value; form.append(input);
    }
    document.body.append(form);
    form.submit();
  }
  localizeVisitor();
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
